import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import LandingPage from "./pages/LandingPage";
import AuthSuccessPage from "./pages/AuthSuccessPage";
import NewBriefingPage from "./pages/NewBriefingPage";
import JobProgressPage from "./pages/JobProgressPage";
import BriefingPage from "./pages/BriefingPage";
import SavedBriefingsPage from "./pages/SavedBriefingsPage";
import SharePage from "./pages/SharePage";
import PromptsPage from "./pages/PromptsPage";

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth/success" element={<AuthSuccessPage />} />
        <Route path="/new" element={<NewBriefingPage />} />
        <Route path="/jobs/:jobId" element={<JobProgressPage />} />
        <Route path="/briefings" element={<SavedBriefingsPage />} />
        <Route path="/briefings/:briefingId" element={<BriefingPage />} />
        <Route path="/share/:token" element={<SharePage />} />
        <Route path="/prompts" element={<PromptsPage />} />
      </Routes>
    </BrowserRouter>
  );
}
